import { WordpressApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const wordPressApi = WordpressApi({}, '/api', axiosInstance);
